import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '@fortem-monorepo/js-utilities';
import { buttonVariants } from '../../ui/button';
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue, } from '../../ui/select';
export const SelectInput = ({ placeholder, options, valueDisabled, size = 'default', className, ...props }) => {
    return (_jsxs(Select, { ...props, children: [_jsx(SelectTrigger
            // @ts-ignore
            , { 
                // @ts-ignore
                size: size, className: cn(buttonVariants({ variant: 'ghost' }), 'justify-between', 'w-[180px] cursor-pointer ', '[&_svg]:opacity-100', className), children: _jsx(SelectValue, { placeholder: placeholder }) }), _jsx(SelectContent, { children: _jsxs(SelectGroup, { children: [placeholder && _jsx(SelectLabel, { children: placeholder }), options.map((option) => {
                            return (_jsx(SelectItem, { value: option.value, disabled: valueDisabled?.(option.value), children: option.label }, option.value));
                        })] }) })] }));
};
